import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/hooks';

export enum SidebarState {
  OPEN,
  COLLAPSED,
}

export const useSidebarState = () => {
  const dispatch = useDispatch();
  const { width: sidebarState, isHover } = useAppSelector(
    state => state.main.sidebarState,
  );

  const isSidebarCollapsed =
    sidebarState === SidebarState.COLLAPSED && !isHover;
  const isSidebarOpen = sidebarState === SidebarState.OPEN;

  const setIsHover = useCallback(
    payload => {
      dispatch({ type: 'SET_HOVER_SIDEBAR', payload: payload });
    },
    [dispatch],
  );

  const toggleSidebar = useCallback(() => {
    dispatch({ type: 'TOGGLE_SIDEBAR' });
  }, [dispatch]);

  return {
    sidebarState,
    isSidebarCollapsed,
    isSidebarOpen,
    isHover,
    toggleSidebar,
    setIsHover,
  };
};
